export default {
    //法语
    DiagnosticReport:'Rapport de diagnostic',
    troubleCode:'Code de défaut',
    time:'Le temps',
    noTItle:'Contrôle du fabricant',
    TestReport:"Rapport d'essai",
    VehicleInformation:'Informations sur le véhicule',
    DataStream:'Flux de données',
    IMReadiness:'Préparation I/M',
    Communication:'Protocole de communication',
    notFaultCode:'Fehlerfreier Code',
    nodataflow:'Aucun flux de données anormal',
    // 语言
    lang:{
        cn:'Chinois',
        de:'Allemand',
        en:'Anglais',
        es:'Espagnol',
        fr:'Français',
        it:'Italien',
        ja:'Japonais',
        ko:'Coréen',
        pt:'Portugais'
    },
    PositioningPrompt:'Activez la fonction de localisation pour obtenir les prix locaux.',
    FaultCode:'Code de défaut',
    AIDiagnosis:'Diagnostic IA',
    AIWait:"Rapport d'IA ou en attente de diagnostic automatique",
    FailedFaultCode:"Impossible d'obtenir les informations sur le code d'erreur",
    AIError:"Échec de l'analyse de l'IA",
    more:'Plus',
    StoredCodes:'code de stockage',
    PendingCodes:'Code à traiter',
    PermanentCodes:'codage permanent',
    Unknown:'inconnu',
    ManufacturerControl:'Contrôle du fabricant'
}